export const getTranslatedText = (
  keyMap: Record<string, string>,
  subCategoryName: string | undefined,
  vars: Record<string, string> | undefined,
  t: Function
): string => {
  if (!subCategoryName) return '';
  const key = keyMap[subCategoryName];
  if (!key) return '';
  let parsedVars = vars;

  if (typeof vars === 'string') {
    try {
      parsedVars = JSON.parse(vars);
    } catch {
      parsedVars = undefined;
    }
  }

  return t(key, parsedVars);
};
